export const blockIconsActivitiesSportsSoccerNew = (
	<span className='material-symbols-outlined'>sports_soccer</span>
);
